const PractitionerCDO = {
  id: '',
  firstName: '',
  lastName: '',
  middleName: '',
  gender: '',
  workPhone: '',
  email: '',
};
export default PractitionerCDO;
